import { getPresetByKey } from '@/config/theme-presets'

const STORAGE_KEY = 'career-theme'

/** 将主题预设的 RGB 值写入 CSS 变量，立即生效 */
export function applyThemePreset(key: string, isDark: boolean) {
  const preset = getPresetByKey(key)
  const colors = isDark ? preset.dark : preset.light
  const root = document.documentElement.style
  root.setProperty('--color-brand', colors.brand)
  root.setProperty('--color-accent', colors.accent)
  root.setProperty('--color-brand-soft', colors.brandSoft)
}

export function getSavedTheme(): string {
  return localStorage.getItem(STORAGE_KEY) || 'crimson'
}

export function saveTheme(key: string) {
  localStorage.setItem(STORAGE_KEY, key)
}
